export const chunkPageElements = (data: any[]) => {
    const chunkArray = (arr: any[], chunkSize: number) => {
        const result = [];
        for (let i = 0; i < arr.length; i += chunkSize) {
            result.push(arr.slice(i, i + chunkSize));
        }
        return result;
    };
    const groupedData = chunkArray(data, 6);
    return groupedData
}